module.exports = __webpack_public_path__ + "static/media/Mountain1.5b47a8bd.jpeg";